import React from "react";
import { Star } from "lucide-react";

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className='auction-card min-w-[300px] rounded-none'>
      <div className='flex items-center mb-4'>
        <div className='w-12 h-12 bg-primary rounded-full flex items-center justify-center mr-3'>
          <span className='text-white font-bold'>
            {testimonial.name.charAt(0)}
          </span>
        </div>
        <div>
          <h4 className='font-semibold'>{testimonial.name}</h4>
          <p className='text-sm text-gray-300'>{testimonial.position}</p>
        </div>
      </div>

      <div className='flex mb-3'>
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={16}
            className={`${
              i < testimonial.rating
                ? "text-yellow-400 fill-current"
                : "text-gray-400"
            }`}
          />
        ))}
      </div>

      <p className='text-gray-300 text-sm mb-4 leading-relaxed'>
        "{testimonial.quote}"
      </p>

      <p className='text-xs text-gray-400'>{testimonial.date}</p>
    </div>
  );
};

export default TestimonialCard;
